"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.surveyFactory = void 0;
const Factory = require("factory.ts");
const mocks_1 = require("../../../mocks");
exports.surveyFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    code: '1234567890',
    name: 'Test Survey',
    status: 0,
    site_id: 500,
    open_date: null,
    close_date: null,
    survey_type: 'registration',
    site_name: 'Test Site',
    created_at: mocks_1.dates.date2000,
    updated_at: mocks_1.dates.date2000,
    is_es_indexed: true,
    survey_summary: null,
    forms: [],
    survey_results_count: 0,
    survey_url: 'http://www.example.com/survey',
    default_url_options: {},
    'default_url_options?': true
});
